import Contaier from "../../components/layout/Container/Container";
import CompleteImg from "../../assets/eservice-img-suss.png";
import Header from "../../components/molecules/Header/Header";
import { useNavigate, useLocation } from "react-router-dom";

const VetHealthInspectionComplete = () => {
  const location = useLocation();
  const bannersType = location.state;

  let bannerName = "Vet Health - Border Control Inspections";
  let inspectionId = location.state?.inspectionId;
  let type = location.state?.type;
  let caseNo = location.state?.inspectionCaseNo;

  let navigate = useNavigate();
  const routeChange = () => {
    let path = `/vethealth-inspections`;
    if (type === "ISR") path = `/isr-inspections`;
    navigate(path);
  };

  return (
    <>
      <Header />
      <Contaier>
        <div className="inner-content pt-5 pb-5">
          <div className="container">
            <div className="landing-page tag-list mt-5 mb-5">
              <figure>
                <img src={CompleteImg} alt="" className="img-fluid" />
              </figure>
              {type === "ISR" && (
                <p>You have successfully updated the Inspection!</p>
              )}
              {type === "Dashboard" && caseNo != undefined && (
                <p>Inspection case {caseNo} has been cancelled.</p>
              )}
              {type !== "ISR" && inspectionId && (
                <p>
                  You have successfully updated the Border Control Inspection!
                </p>
              )}
              {type !== "ISR" && !inspectionId && (
                <p>
                  You have successfully submitted the Border Control Inspection!
                </p>
              )}
              <button
                type="button"
                className="btn btn-success mt-4"
                onClick={routeChange}
              >
                {type === "ISR" && <span>Back to Inspection Updates</span>}
                {type !== "ISR" && (
                  <span>Back to Border Control Inspections</span>
                )}
              </button>
            </div>
          </div>
        </div>
      </Contaier>
    </>
  );
};

export default VetHealthInspectionComplete;
